<template>
    <div class="company-Main">
        <p class="current">当前位置：<span>公司详情</span></p>
        <div class="company-info">
            <div class="top_title">
                <p class="companyNameJoin">{{ companyInfo.name }}</p>
                <el-button type="primary" @click="HnadleInquiry">询价</el-button>
            </div>
            <div v-show="companyInfo.firstFile.FileUrl != ''" class="joinImage">
                <img :src="companyInfo.firstFile.FileUrl" style="width: 100%;height: 100%; object-fit: cover;" alt="">
            </div>
            <div class="company-detail">
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item title="公司简介" name="1">
                        <div v-html="companyInfo.intro"></div>
                    </el-collapse-item>
                    <el-collapse-item title="营业执照" name="2">
                        <img v-show="companyInfo.license_file != ''" :src="companyInfo.license_file" alt="">
                    </el-collapse-item>
                    <el-collapse-item title="资质图片" name="3">
                      <div class="cert-box">
                        <img v-show="item.FileUrl != ''" :src="item.FileUrl" alt="" v-for="item in companyInfo.cert_file" :key="item.id">
                      </div>
                    </el-collapse-item>
                    <el-collapse-item title="产品服务" name="4">
                        <div class="company-product">
                            <div v-for="item in companyproduct" :key="item.id" class="product-box">
                                <img :src="item.firstFile.FileUrl" alt="">
                                <p class="product-name">{{ item.name }}</p>
                                <div class="product-price">
                                    <p>￥{{ item.price }}</p>
                                    <p style="font-size: 12px; color: #666666;padding-top: 7px;margin-left: 5px;">/{{ item.unit }}</p>    
                                </div>
                            </div>
                           
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
    </div>
</template>
<script>
export default({
    data(){
        return {
            companyInfo: [],
            activeNames: ['1','2','3','4'],
            companyproduct: []
        }
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        HnadleInquiry(){

            this.$router.push({
                path: '/inquiry',
                query: {
                    company_id : this.companyInfo.id,
                    company_name: this.companyInfo.name
                }
            })
        }
    },
    mounted(){
        let data = {
            id: this.$route.query.key
        }
        this.$store.dispatch('menu/companyinfo',data)
            .then(res => {
                if(res.ok){
                    this.companyInfo = res.data
                }
            })
        this.$store.dispatch('menu/companyproduct',data)
            .then(res => {
                if(res.ok){
                    this.companyproduct = res.data.items
                }
            })
    }
})
</script>
<style scoped lang="scss">
@import url(../../css/collapse.css);
.top_title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid #f2f2f2;
    .el-button{
        background-color: #ff9828;
        border: 1px solid #ff9828;
        border-radius: 50px;
    }
}
.company-product{
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
    align-items: center;
    .product-box{
        width: 350px;
        padding: 10px 10px;
        margin: 10px 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        img{
            width: 350px;height: 350px;
        }
        .product-name{
            font-size: 18px;
            font-weight: 700;
        }
        
        .product-price{
            font-size: 18px;
            font-weight: 600px;
            margin-top: 10px;
            color: red;
            display: flex;
            justify-content: flex-start;
        }
    }
}

@media screen and (max-width: 540px) {
    .company-Main{
        width: 96%;
        padding: 10px 0px;
    }
    .current{
        margin-top: -45px;
        position: relative;
        font-size: 16px;
        color: #333;
    }
    .current span{
        font-size: 16px;
        cursor: pointer;
        color: #666666;
    }
    .company-info{
        width: 100%;
        margin: 10px auto;
    }
    .companyNameJoin{
        font-size: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-left: 10px;
    }
    .joinImage{
        width: 96%; height: 200px;
        margin: 0 auto;
    }
    .company-detail{
        width: 100%;
        
    }
    .company-detail .el-collapse-item__content img{
        max-width: 100%;max-height: 260px;
    }
}
</style>